import React from 'react'
import { Flex, Text, Box, breakpoints } from '@gassan-ui'
import LocalizedLink from '@components/Localization/LocalizedLink'
import { MarginTopProps, MarginBottomProps } from 'styled-system'
import styled from 'styled-components'
import { micro } from '@gassan-ui'

const Separator = styled.span`
  width: 1px;
  height: 10px;
  background: currentColor;
  transform: rotate(20deg);
  margin: auto 0.5rem;

  @media screen and (min-width: ${breakpoints.large}) {
    margin: auto 1rem;
  }
`

const Anchor = styled.a`
  ${micro};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: currentColor;
  transition: color 0.1s ease;
  @media (hover: hover) and (pointer: fine) {
    &:hover,
    &:focus {
      color: ${p => p.theme.colors.shades[800]};
    }
  }
`

export type BreadcrumbItem = {
  label: string
  as?: string
  href?: string
}

type Props = MarginTopProps &
  MarginBottomProps & {
    items: BreadcrumbItem[]
  }

export const Breadcrumbs: React.FC<Props> = ({ mt, mb = '1rem', items }) => {
  return (
    <Box display={{ _: 'none', large: 'flex' }} color="shades.500" mt={mt} mb={mb} width="90%">
      <Flex alignItems="center">
        <LocalizedLink href="/" as="/">
          <Anchor href="/">Home</Anchor>
        </LocalizedLink>
      </Flex>

      {items.map((item, key) => (
        <Flex alignItems="center" key={key} width="auto" maxWidth={{ large: '35%', xlarge: '40%' }}>
          <Separator />
          {item.href && key + 1 !== items.length ? (
            <LocalizedLink href={item.href} as={item.as}>
              <Anchor href={item.as}>{item.label}</Anchor>
            </LocalizedLink>
          ) : (
            <Text
              variant="micro"
              mb="0"
              color="currentColor"
              as="span"
              style={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}
            >
              {item.label}
            </Text>
          )}
        </Flex>
      ))}
    </Box>
  )
}
